import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined'
import RepeatOutlinedIcon from '@mui/icons-material/RepeatOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

export const ResponsibleUseItems = [
  {
    Icon: ChatBubbleOutlineIcon,
    title: 'Iniciar siempre vos la conversación',
    body: 'WhatsApp favorece los intercambios donde el destinatario responde. Si siempre sos vos quien abre el chat sin obtener respuesta, el algoritmo lo detecta como comportamiento intrusivo.',
  },
  {
    Icon: PersonOffOutlinedIcon,
    title: 'Enviar mensajes a contactos que no te tienen agendado',
    body: 'Cuando tu número no está guardado en la agenda del destinatario, es más probable que reporte el mensaje como spam, lo que impacta directamente en la reputación de tu número.',
  },
  {
    Icon: SendOutlinedIcon,
    title: 'Enviar mensajes que no generan respuesta',
    body: 'Un alto volumen de mensajes enviados sin respuesta es una señal de alerta para WhatsApp. Priorizá contactos con quienes ya existe un vínculo activo y asegurate de que el contenido invite al diálogo.',
  },
  {
    Icon: RepeatOutlinedIcon,
    title: 'Enviar piezas publicitarias repetitivas o archivos sin contexto',
    body: 'El reenvío masivo de imágenes, flyers o archivos sin una introducción personalizada activa los filtros anti-spam. Cada envío debe tener un contexto claro y relevante para quien lo recibe.',
  },
]

export const responsibleUseHeader = {
  icon: WarningAmberIcon,
  title: 'Uso responsable de la herramienta',
  subtitle: 'Es importante el uso sano de la herramienta para proteger tu número de WhatsApp.',
}

export const responsibleUseTip = {
  icon: LightbulbOutlinedIcon,
  text: 'Usá Calu de forma responsable y respetuosa para mantener tu número seguro y tu comunicación efectiva.',
}
